module.exports = __webpack_public_path__ + "friend8.png?a9e04b009b9cd411a2cd9503aae8bc83";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend8.png
// module id = 481
// module chunks = 0